import React, {useEffect, useState} from 'react';
import useHboLogin from './hooks/useHboLogin';
import {getTranslationsState, hasError, isAllDataLoaded, isLoading} from "./selectors";
import Loader from "components/Loader";
import {converter} from "helpers/converter";
import * as constants from "./constants";
import _ from "lodash";
import FormsTabs from "./components/Form";

const HboLoginRefactor = () => {
  const {
    state,
    getForms,
    handleTabChange,
    renderRegionNotSupported,
    renderErrorOnRequests,
    renderPinModal
  } = useHboLogin();

  const [Header1Text, setHeader1Text] = useState('');
  const [Header2Text, setHeader2Text] = useState('');

  useEffect(() => {
      if(state.metadata?.model){
          setHeader1Text(converter.convertApa(
              getTranslationsState(state),
              constants.SSO_LOGIN,
          ))
          setHeader2Text(converter.convertApa(
              getTranslationsState(state),
              constants.SSO_SELECT_OPTION_LABEL,
          ))
      }
  }, [state])


    if (isLoading(state))
    return <Loader active />;
  if (hasError(state)) return renderErrorOnRequests();



  /*const Header1Text = ;

  const Header2Text = ;*/
  const forms = getForms();
  const logoFromExternalLogin = state?.assets?.model?.claro_logo_loading_xdk || constants.DEFAULT_LOGO

  if (_.isEmpty(forms)) return renderRegionNotSupported();

  return (
      <div className="hbo-login hbo-content">
        <img
            src={logoFromExternalLogin}
            alt="clarovideo"
            className="img-responsive"
        />
          <h1 className="hbo-message">{Header1Text}</h1>
        <h2 className="hbo-header_title">{Header2Text}</h2>

        <FormsTabs onTabChange={handleTabChange} forms={forms} />
        {state.pinModal.show ? renderPinModal() : null}
      </div>
  );
};

export default HboLoginRefactor;
